import React from "react";
// Make sure the path is correct
import set from '../images/nr8.jpg';

const ImageVideoSection = () => {
    return (
        <div className="container-fluid py-5"> {/* Outer container with padding */}
            <div className="row justify-content-center"> {/* Bootstrap Row to center content */}
                <div className="col-12 d-flex justify-content-center align-items-center">
                    <img
                        src={set}
                        alt="Placeholder"
                        className="img-fluid" // Responsive image
                        style={{ maxHeight: '500px' }} // Optional: Limit height
                    />
                </div>
            </div>
        </div>
    );
};

export default ImageVideoSection;